import {CloseIcon} from "@unibuddy/patron";

export default CloseIcon;
